import { IRewardItem } from '../State/reducers/score';
import { BigProduct } from '../UI/PopUps/Shop/Products/BigProduct';
import { ShopProduct } from '../UI/PopUps/Shop/Products/ShopProduct';
import { SmallProduct } from '../UI/PopUps/Shop/Products/SmallProduct';
import { ItemIDs } from './Items';
import { FreeGift } from '../UI/PopUps/Shop/Products/FreeGift';
import DateUtils from '../Utils/DateUtils';

export const SHOP_GIFT_TIME: number = DateUtils.hoursToMilliseconds(3);

export interface IShopCatalogItem {
    uiClass: typeof ShopProduct;
    items: IRewardItem[];
    label?: ShopLabels;
    require?: ShopProductIDs;
    limit?: number;
    tint?: number;
}

export enum ShopProductIDs {
    StarterPack = 'starter_pack',
    VipPack = 'vip_pack',
    BigPack = 'big_pack',
    CoinsS = 'coins_s',
    CoinsM = 'coins_m',
    CoinsL = 'coins_l',
    CoinsXL = 'coins_xl',
    FreeGift = 'free_gift',
}

enum ShopLabels {
    BestValue = 1,
    SpecialOffer,
    MostPopular,
}

export const ShopCatalog: Record<ShopProductIDs, IShopCatalogItem> = {
    [ShopProductIDs.StarterPack]: {
        uiClass: BigProduct,
        items: [
            { id: ItemIDs.COINS, val: 3000 },
            { id: ItemIDs.HIGHLIGHT, val: 3 },
            { id: ItemIDs.SHUFFLE, val: 3 },
            { id: ItemIDs.MAGNET, val: 3 },
            { id: ItemIDs.FIRECRACKER, val: 3 },
        ],
        limit: 1,
        label: ShopLabels.SpecialOffer,
        tint: 0x26e500,
    },
    [ShopProductIDs.VipPack]: {
        uiClass: BigProduct,
        items: [
            { id: ItemIDs.COINS, val: 6000 },
            { id: ItemIDs.HIGHLIGHT, val: 6 },
            { id: ItemIDs.SHUFFLE, val: 6 },
            { id: ItemIDs.MAGNET, val: 6 },
            { id: ItemIDs.FIRECRACKER, val: 6 },
        ],
        label: ShopLabels.SpecialOffer,
        require: ShopProductIDs.StarterPack,
        tint: 0xffea00,
    },
    [ShopProductIDs.BigPack]: {
        uiClass: BigProduct,
        items: [
            { id: ItemIDs.COINS, val: 30000 },
            { id: ItemIDs.HIGHLIGHT, val: 15 },
            { id: ItemIDs.FIRECRACKER, val: 15 },
        ],
    },
    [ShopProductIDs.FreeGift]: {
        uiClass: FreeGift,
        items: [{ id: ItemIDs.COINS, val: 25 }],
    },
    [ShopProductIDs.CoinsS]: {
        uiClass: SmallProduct,
        items: [{ id: ItemIDs.COINS, val: 2000 }],
        label: ShopLabels.MostPopular,
    },
    [ShopProductIDs.CoinsM]: {
        uiClass: SmallProduct,
        items: [{ id: ItemIDs.COINS, val: 6000 }],
    },
    [ShopProductIDs.CoinsL]: {
        uiClass: SmallProduct,
        items: [{ id: ItemIDs.COINS, val: 20000 }],
    },
    [ShopProductIDs.CoinsXL]: {
        uiClass: SmallProduct,
        items: [{ id: ItemIDs.COINS, val: 100000 }],
        label: ShopLabels.BestValue,
    },
};
